import { all, takeLatest } from 'redux-saga/effects';
import { SIGN_UP_REQUEST, RESEND_VERIFICATION_REQUEST } from './constants';
import { setModal } from 'containers/RootModal/actions';
import { signUpFailure, signUpSuccess, resendVerificationSuccess,
resendVerificationFailure } from './actions';
import {HAS_ALREADY_SIGNED_UP_MODAL,VERIFICATION_RESENT_FAILURE_MODAL
} from 'containers/RootModal/constants';
import { apiSaga } from 'sagas';
import { postRegistration, resendVerificationEmail } from 'utils/api';

export function* signUpFlow({ payload }) {
  yield* apiSaga(postRegistration, [payload], signUpSuccess, [
    signUpFailure,
    () => setModal({ modalType: HAS_ALREADY_SIGNED_UP_MODAL })
  ]);

}

export function* resendVerificationFlow({ payload }) {
  yield*  apiSaga(resendVerificationEmail, [payload], resendVerificationSuccess, [resendVerificationFailure, () => setModal({modalType: VERIFICATION_RESENT_FAILURE_MODAL})]);
}

export default function* watchSignUp() {
  yield all([
    takeLatest(SIGN_UP_REQUEST, signUpFlow),
    takeLatest(RESEND_VERIFICATION_REQUEST, resendVerificationFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/sagas.js